// @flow
import React from 'react';
import { Input } from 'angieslist-react-components';
import { get } from 'lodash';
import { withRouter } from 'react-router';
import type { MetricCategory } from '../../../types';
import './categoryList.scss';

type Props = {
  categories?: MetricCategory[],
  basePath?: string,
  categoryId?: number,
  serviceProviderId: string,
  onSelect: ({ categoryId: any, SPID: string }) => any,
  router: {
    replace: (path: string) => any
  }
};

const MobileCategoryListComponent = ({
  categories, basePath, categoryId, serviceProviderId, router: { replace }, onSelect,
}: Props) =>
  (
    <Input
      id="mobile-category-list--category-select"
      type="select"
      label="CATEGORIES"
      onChange={(e) => {
        onSelect({
          categoryId: e.target.value,
          SPID: serviceProviderId,
        });
        replace(`/app/store/${serviceProviderId}/reviews?categoryId=${e.target.value}`);
      }}
    >
      {
        (categories || []).map(category => (
          <option
            key={category.id}
            value={category.id}
            selected={category.id === categoryId}
            disabled={get(category, 'displayReviewCount', 0) < 1}
          >
            {get(category, 'name', '')} ({get(category, 'displayReviewCount', '')})
          </option>
        ))
      }
    </Input>
  );

export default (withRouter(MobileCategoryListComponent): any);



// WEBPACK FOOTER //
// ./src/modules/store/browser/components/reviews/MobileCategoryList.js